// src/pages/Home.js
// Página inicial - será redesenhada na Fase 3 como Hub central
import React from "react";
import useSEO from "../hooks/useSEO";
import seoConfig from "../config/seo/seoConfig";
import BannerBackground from "../Assets/home-banner-background.png";
import BannerImage from "../Assets/home-banner-image.png";
import About from "../Components/About";
import Certificate from "../Components/Certificate";
import Testimonial from "../Components/Testimonial";
import Contact from "../Components/Contact";

const Home = () => {
  useSEO();

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': ['WholesaleStore', 'LocalBusiness'],
    name: 'Verde Musgo Natural',
    description:
      'Fornecedor de hortaliças no atacado em Embu-Guaçu para restaurantes, lanchonetes, hortifrutis e estabelecimentos da região.',
    url: 'https://verdemusgonatural.com.br/',
    telephone: seoConfig.company.whatsapp,
    image: 'https://verdemusgonatural.com.br/home-banner-image.png',
    areaServed: [
      'Embu-Guaçu',
      'Itapecerica da Serra',
      'Taboão da Serra',
      'São Lourenço da Serra',
      'Juquitiba',
      'Zona Sul de São Paulo',
      'Zona Oeste de São Paulo'
    ],
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Embu-Guaçu',
      addressRegion: 'SP',
      addressCountry: 'BR'
    },
    sameAs: [
      'https://instagram.com/verdemusgo.natural',
      'https://facebook.com/verdemusgo.natural'
    ]
  };

  return (
    <div>
      <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      {/* Hero/Banner Section */}
      <main id="main" className="home-banner-container">
        <div className="home-bannerImage-container">
          <img src={BannerBackground} alt="Fundo decorativo com elementos naturais e orgânicos representando agricultura sustentável" />
        </div>
        <header className="home-text-section">
          <h1 className="primary-heading">
            Distribuição e Venda de Hortaliças no Atacado em Embu-Guaçu
          </h1>
          <h2 className="primary-heading" style={{ fontSize: '1.6rem', marginTop: '1rem' }}>
            Folhosas Sem Agrotóxicos para Restaurantes, Lanchonetes e Hortifrutis
          </h2>
          <p className="primary-text">
            Produzimos e entregamos hortaliças e folhosas frescas com colheita no dia, rendimento de 100% e durabilidade superior na câmara fria do cliente, com um atendimento direto e confiável para pequenas e médias operações.
          </p>
          <h2 className="primary-heading" style={{ fontSize: '1.45rem', marginTop: '1rem' }}>
            Atendimento e Entregas Diretas em Embu-Guaçu e Região
          </h2>
          <p className="primary-text">
            Atendemos Embu-Guaçu, Itapecerica da Serra, Taboão da Serra, São Lourenço da Serra, Juquitiba e zonas Sul e Oeste de São Paulo com entregas regulares para restaurantes, lanchonetes, hortifrutis e cozinhas que valorizam frescor, consistência e logística prática.
          </p>
        </header>
        <div className="home-image-section">
          <img src={BannerImage} alt="Produtos agroecológicos frescos: verduras, legumes e frutas orgânicas cultivadas de forma sustentável" />
        </div>
      </main>

      {/* Seções atuais temporárias - Será redesenhado na Fase 3 */}
      <About />
      <Certificate />
      <Testimonial />
      <Contact />
    </div>
  );
};

export default Home;
